import { useState } from 'react';
import SEOOptimizer from './components/SEOOptimizer';
import BlogGenerator from './components/BlogGenerator';
import KeywordTracker from './components/KeywordTracker';
import CompetitorTracker from './components/CompetitorTracker';

function App() {
  const [activeView, setActiveView] = useState('seo');
  const [blogMounted, setBlogMounted] = useState(false);

  const openBlog = () => {
    setBlogMounted(true);
    setActiveView('blog');
  };

  return (
    <div style={{ margin: '0 auto', padding: '20px 40px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <nav style={{ marginBottom: '20px' }}>
        <button
          onClick={() => setActiveView('seo')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            border: activeView === 'seo' ? 'none' : '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: activeView === 'seo' ? '#0084ff' : '#fff',
            color: activeView === 'seo' ? '#fff' : '#333',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          📊 产品SEO优化
        </button>
        <button
          onClick={() => setActiveView('keywords')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            border: activeView === 'keywords' ? 'none' : '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: activeView === 'keywords' ? '#0084ff' : '#fff',
            color: activeView === 'keywords' ? '#fff' : '#333',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          📈 关键词排名
        </button>
        <button
          onClick={openBlog}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            border: activeView === 'blog' ? 'none' : '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: activeView === 'blog' ? '#0084ff' : '#fff',
            color: activeView === 'blog' ? '#fff' : '#333',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          📝 博客文章生成
        </button>
        <button
          onClick={() => setActiveView('competitors')}
          style={{
            padding: '10px 20px',
            border: activeView === 'competitors' ? 'none' : '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: activeView === 'competitors' ? '#0084ff' : '#fff',
            color: activeView === 'competitors' ? '#fff' : '#333',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          🆚 竞品关键词
        </button>
      </nav>

      <main>
        {activeView === 'seo' && <SEOOptimizer />}
        {activeView === 'keywords' && <KeywordTracker />}
        {blogMounted && (
          <div style={{ display: activeView === 'blog' ? 'block' : 'none' }}>
            <BlogGenerator />
          </div>
        )}
        {activeView === 'competitors' && <CompetitorTracker />}
      </main>
    </div>
  );
}

export default App;
